import React from "react";

export default function IconButton(props) {
  let { className, imagen, value, ...other } = props;
  return (
    <button
      className={`btn-icon ${className ? className : ""}`}
      value={value ? value : ""}
      style={{ backgroundImage: imagen ? `url(${imagen})` : "" }}
      {...other}
    ></button>
  );
}
